/**
 * FIRST-SESSION HELPERS the guide switches on while Chapter 1 runs (engine.ts `firstSessionHelpers`), read by the
 * game systems they bend — kept as a tiny module so a system asks one question and never imports the tutorial:
 *   • boostFirstCrop — the player's first planting ripens in FIRST_CROP_SECONDS (useGreenhouse), so the first
 *     harvest is a minute away, not four;
 *   • sureBite — the first cast always gets a bite (useGarden), so "catch a fish" never stalls on a day-one rig's
 *     empty cast;
 *   • tutorialBug — while Chapter 2's "catch a bug" is the step on screen, picking up the net sends ONE pinned, easy
 *     bug (useGarden), so the step never waits on the weather or the hour and its quarry cannot wander off.
 * All are false once the step they serve is done (or the tutorial skipped).
 */
export interface GuideHelpers { boostFirstCrop: boolean; sureBite: boolean; tutorialBug: boolean }
export const NO_HELPERS: GuideHelpers = { boostFirstCrop: false, sureBite: false, tutorialBug: false };
let flags: GuideHelpers = NO_HELPERS;

export function setGuideHelpers(next: GuideHelpers): void { flags = next; }
export function guideHelpers(): GuideHelpers { return flags; }
